import React from 'react';
import { Circle, G, Line, Polygon, Rect, Text as SvgText } from 'react-native-svg';
import { DiagramCanvas } from '../DiagramCanvas';
import { FormulaTag } from '../FormulaTag';
import { LeaderLine } from '../LeaderLine';
import { CoilSymbol } from '../primitives/CoilSymbol';
import { DT } from '../tokens';

/** Q_s = 1.08·CFM·ΔT — heating coil example: cool entering → warm leaving. */
export function DiagramSensibleHeat() {
  const dy = 100, dh = 65;
  const cy = dy + dh / 2;

  return (
    <DiagramCanvas>
      {/* Cool entering */}
      <Rect x={20} y={dy} width={70} height={dh} fill="rgba(122,170,187,0.2)" stroke={DT.stroke} strokeWidth="1.5" />
      <Line x1={28} y1={cy} x2={84} y2={cy} stroke={DT.arrow} strokeWidth="1.6" />
      <Polygon points={`86,${cy} 80,${cy - 4} 80,${cy + 4}`} fill={DT.arrow} />

      {/* Heating coil (orange tint) */}
      <CoilSymbol x={90} y={dy} width={150} height={dh} loops={5} />
      <Rect x={92} y={dy + 2} width={146} height={dh - 4} fill="rgba(255,107,26,0.06)" />

      {/* Warm leaving */}
      <Rect x={240} y={dy} width={80} height={dh} fill="rgba(255,107,26,0.2)" stroke={DT.stroke} strokeWidth="1.5" />
      <Line x1={248} y1={cy} x2={310} y2={cy} stroke={DT.arrow} strokeWidth="1.6" />
      <Polygon points={`312,${cy} 306,${cy - 4} 306,${cy + 4}`} fill={DT.arrow} />

      {/* Thermometers T1 / T2 */}
      {[
        { x: 55, T: 'T₁', color: '#7AAABB', tilt: 5 },
        { x: 280, T: 'T₂', color: '#FF6B1A', tilt: -6 },
      ].map((t, i) => (
        <G key={i}>
          <Line x1={t.x} y1={dy} x2={t.x} y2={dy - 18} stroke={DT.leader} strokeWidth="1.2" />
          <Circle cx={t.x} cy={dy - 30} r={11} fill={DT.fill} stroke={DT.stroke} strokeWidth="1.2" />
          <Line x1={t.x} y1={dy - 30} x2={t.x + t.tilt} y2={dy - 36} stroke={t.color} strokeWidth="1.6" />
          <Circle cx={t.x} cy={dy - 30} r={1.5} fill={t.color} />
          <SvgText x={t.x} y={dy - 44} fill={t.color} fontSize="9" fontFamily={DT.mono} textAnchor="middle" fontWeight="700">{t.T}</SvgText>
        </G>
      ))}

      {/* ΔT brace */}
      <Line x1={55} y1={dy - 56} x2={280} y2={dy - 56} stroke={DT.varColor} strokeWidth="1" />
      <Polygon points={`55,${dy - 56} 61,${dy - 53} 61,${dy - 59}`} fill={DT.varColor} />
      <Polygon points={`280,${dy - 56} 274,${dy - 53} 274,${dy - 59}`} fill={DT.varColor} />
      <SvgText x={167} y={dy - 60} fill={DT.varColor} fontSize="10" fontFamily={DT.mono} textAnchor="middle" fontWeight="700">ΔT = T₂ − T₁</SvgText>

      {/* Labels */}
      <LeaderLine x1={55} y1={cy} x2={20} y2={210} varName="CFM" desc="airflow" anchor="start" />
      <LeaderLine x1={167} y1={dy + dh - 6} x2={150} y2={210} varName="Q_s" desc="sensible BTU/h" anchor="middle" />
      <LeaderLine x1={280} y1={cy} x2={310} y2={210} varName="ΔT" desc="dry-bulb" anchor="end" />

      <FormulaTag formula="Q_s = 1.08 · CFM · ΔT   (dry-bulb only)" />
    </DiagramCanvas>
  );
}
